<template>
  <svg
    width="16px"
    height="16px"
    viewBox="0 0 16 16"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <g
      id="Symbols"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g
        id="side-menu"
        transform="translate(-32, -298.0775)"
        fill="#FFFFFF"
        fill-rule="nonzero"
      >
        <g
          id="sleep_FILL1_wght400_GRAD0_opsz48"
          transform="translate(32, 298.0775)"
        >
          <path
            id="Shape"
            d="M8.06991261,16 C6.95131086,16 5.90262172,15.7866667 4.92384519,15.36 C3.94506866,14.9333333 3.09280067,14.3566667 2.3670412,13.63 C1.64128173,12.9033333 1.065335,12.05 0.639200999,11.07 C0.213067,10.09 0,9.04 0,7.92 C0,5.97333333 0.619225968,4.25666667 1.8576779,2.77 C3.09612984,1.28333333 4.6741573,0.36 6.5917603,0 C6.35205993,1.30666667 6.42530171,2.59 6.81148564,3.85 C7.19766958,5.11 7.86350395,6.21333333 8.80898876,7.16 C9.75447357,8.10666667 10.8564295,8.77666667 12.1148564,9.17 C13.3732834,9.56333333 14.6616729,9.64 15.980025,9.4 C15.6337911,11.32 14.7149397,12.9 13.2234707,14.14 C11.7320017,15.38 10.014149,16 8.06991261,16 Z M13.2833958,5.44 L12.4444444,3.56 L10.5667915,2.72 L12.4444444,1.88 L13.2833958,0 L14.1223471,1.88 L16,2.72 L14.1223471,3.56 L13.2833958,5.44 Z"
          ></path>
        </g>
      </g>
    </g>
  </svg>
</template>
